/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/tosProduct.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

const log: any = LoggerModule?.getInstance();

export interface ITOSProductMethods extends IPluginMethodMap {
  tosProduct(args: TOSProductProps): Promise<any>;
}

export interface TOSProductProps {
  apiURL?: string;
  gtin: string;
  action: string;
  service_agreement: string;
  isAgeConfirmed: boolean;
}

export class TOSProductService implements IAgentPlugin {
  readonly methods?: ITOSProductMethods;

  constructor() {
    this.methods = {
      tosProduct: this.tosProduct.bind(this),
    };
  }

  async tosProduct(args: TOSProductProps) {
    log.info(`in tos service: `, args);
    try {
      const res = await axios.post(
        `${args.apiURL}${config?.tosProductEP}`,
        {
          action: args?.action,
          gtin: args?.gtin,
          service_agreement: args?.service_agreement,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      if (res?.data) {
        console.log(` On Success of prduct TOS data:`, res?.data);
        return { ...res?.data, isAgeConfirmed: args?.isAgeConfirmed };
      }
    } catch (err: any) {
      return err;
    }
  }
}
